export const userFullNameBuilder = {
  build: (preferredFirstName: string | undefined, firstName: string | undefined, lastName: string | undefined) => {
    return preferredFirstName || firstName || lastName ? `${preferredFirstName || firstName} ${lastName || ''}` : '--';
  },
};
